import styled from 'styled-components';

export const PavementProjectsHeader = styled.header`
  padding: 1.5rem 1.5rem 3rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};

  & > button {
    margin-bottom: 1rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem;
  margin-bottom: 0.5rem;
`;

export const StructureSpan = styled.span``;
